import {Alert, Button, Card, Divider, Table} from "antd"
import React, {useContext, useEffect, useState} from "react"
import { bulkCheckboxesPreview, getMappedData, groupedCheckboxesPreview, singleCheckboxPreview } from "../util";
import {CalendarOutlined, CheckOutlined, CloseOutlined, EyeInvisibleOutlined, EyeOutlined} from '@ant-design/icons';
import {GlobalContext} from "../../../context/GlobalContext";
import {roleValues as rolesValues, roleValues} from "../../../config/roles";
import {maskName, toTitleCase} from "../../../utils/common";
import {useNavigate, useSearchParams} from "react-router-dom";

export const Review = ({formData, maskThisFullName, maskThisPhone, mode, campaignUUID, interviewId}) => {
  const [searchParams] = useSearchParams();
  const section = searchParams.get('section');
  const { user } = useContext(GlobalContext);
  const hasEditPermission = (user.role === roleValues.admin || user.role === roleValues.dataProtectionOfficer || user.role === roleValues.projectCoordinator);
  const [basicInfo, setBasicInfo] = useState([]);
  const [violenceInformation, setViolenceInformation] = useState([]);
  const [currentImpact, setCurrentImpact] = useState([]);
  const [concordanceCard, setConcordanceCard] = useState([]);
  const [individualIRMPackage, setIndividualIRMPackage] = useState([]);
  const [maskState, setMaskState] = useState(true);
  const [maskStatePhone, setMaskStatePhone] = useState(true);
  const navigate = useNavigate();
  const handleMaskStateChange = (status) => {
    setMaskState(status);
  }
  const handleMaskStatePhoneChange = (status) => {
    setMaskStatePhone(status);
  }
  useEffect(() => {
    maskThisFullName(!maskState)
  }, [maskState]);
  useEffect(() => {
    maskThisPhone(!maskStatePhone)
  }, [maskStatePhone]);
  useEffect(() => {
    let userBasicInfo = [
      {
        key: "fullName",
        title: "Full Name",
        value1: (
            <>
              {formData.filteredFullName || maskName(formData.fullName)}
              { user.role === rolesValues.admin && <>
                {maskState && <> <EyeInvisibleOutlined onClick={() => handleMaskStateChange(false)}/></> }
                {!maskState && <> <EyeOutlined onClick={() => handleMaskStateChange(true)}/></> }
              </>}
            </>
        ),
      },
      {
        key: "personalCode",
        title: "Personal Code",
        value1: formData.personalCode || 'n/a',
      },
      {
        key: "address",
        title: "Address",
        value1: formData.address,
      },
      {
        key: "age",
        title: "Age",
        value1: formData.age,
      },
      {
        key: "religion",
        title: "Religion",
        value1: formData.religion,
      },
      {
        key: "caste",
        title: "Caste",
        value1: formData.caste,
      },
      {
        key: "noOfChildren",
        title: "No of Children",
        value1: formData.noOfChildren,
      },
      {
        key: "sourceOfLivelihood",
        title: "Employment/Source of Livelihood",
        value1: formData.sourceOfLivelihood,
      },
      {
        key: "gender",
        title: "Gender",
        value1: toTitleCase(formData.gender),
      },
      {
        key: "contactNumber",
        title: "Contact Number",
        value1: (
            <>
              {formData.filteredPhone || maskName(formData.contactNumber)}
              { user.role === rolesValues.admin && <>
                {maskStatePhone && <> <EyeInvisibleOutlined onClick={() => handleMaskStatePhoneChange(false)}/></> }
                {!maskStatePhone && <> <EyeOutlined onClick={() => handleMaskStatePhoneChange(true)}/></> }
              </>}
            </>
        ),
      },
      {
        key: "languageSpoken",
        title: "Language Spoken",
        value1: formData.languageSpoken,
      },
      {
        key: "maritalStatus",
        title: "Marital Status",
        value1: toTitleCase(formData.maritalStatus),
      },
      {
        key: "referencePersonCodeName",
        title: "Code Name of the Reference Person",
        value1: formData.referencePersonCodeName,
      },
      {
        key: "referrals",
        title: "Referrals",
        value1: (
            <>
              {formData.referrals && formData.referrals.map((item, index) => (
                  <div key={index}><CheckOutlined style={{ fontSize: 10 }} /> {item}</div>
              ))}
            </>
        ),
      },
    ]
    if (user.role === rolesValues.supervisor) {
      userBasicInfo = userBasicInfo.filter((item) => item.key !== 'fullName')
    }
    setBasicInfo(userBasicInfo);
    setViolenceInformation([
      {
        key: "isDocumented",
        title: getMappedData("isDocumented"),
        value1: formData.isDocumented,
      },
      {
        key: "documentStorage",
        title: "if so, where are the documents stored?",
        // value1: formData.documentStorage,
        value1: (
            <>
              {formData.documentStorage && formData.documentStorage.map((item, index) => (
                  <div key={index}><CheckOutlined style={{ fontSize: 10 }} /> {toTitleCase(item)}</div>
              ))}
            </>
        ),
      },
      {
        key: "otherDocumentStorage",
        title: "If others, please specify",
        value1: formData.otherDocumentStorage,
      },
      {
        key: "typeOfSexualViolence",
        title: "Type of sexual violence",
        value1: (
          <>
            {formData.typeOfSexualViolence && formData.typeOfSexualViolence.map((item, index) => (
              <div key={index}><CheckOutlined style={{ fontSize: 10 }} /> {toTitleCase(item)}</div>
            ))}
          </>
        ),
      },
      {
        key: "otherTypeOfSexualViolence",
        title: "Other forms of sexual violence, please specify",
        value1: formData.otherTypeOfSexualViolence,
      },
      {
        key: "otherFormsOfViolence",
        title: getMappedData('otherFormsOfViolence'),
        value1: (
          <>
            {formData.otherFormsOfViolence && formData.otherFormsOfViolence.map((item, index) => (
              <div key={index}><CheckOutlined style={{ fontSize: 10 }} /> {toTitleCase(item)}</div>
            ))}
          </>
        ),
      },
      {
        key: "otherFormsOfViolenceNotes",
        title: "Other Notes",
        value1: formData.otherTypeOfSexualViolence,
      },
    ]);
    setCurrentImpact([
      {
        key: "currentImpact_1",
        title: (
          <div>
            {getMappedData('currentImpact_1')}
          </div>
        ),
        value1: formData.currentImpact_1,
      },
      {
        key: "currentImpact_2",
        title: (
          <div>
            {getMappedData('currentImpact_2')}
          </div>
        ),
        value1: formData.currentImpact_2,
      },
      {
        key: "currentImpact_3",
        title: getMappedData('currentImpact_3'),
        value1: formData.currentImpact_3,
      },
      {
        key: "currentImpact_4",
        title: getMappedData('currentImpact_4'),
        value1: formData.currentImpact_4,
      },
      {
        key: "currentImpact_5",
        title: getMappedData('currentImpact_5'),
        value1: formData.currentImpact_5,
      },
      {
        key: "currentImpact_6",
        title: getMappedData('currentImpact_6'),
        value1: formData.currentImpact_6,
      },
      {
        key: "currentImpact_7",
        title: getMappedData('currentImpact_7'),
        value1: formData.currentImpact_7,
      },
      {
        key: "currentImpact_8",
        title: getMappedData('currentImpact_8'),
        value1: formData.currentImpact_8,
      },
      {
        key: "currentImpact_9",
        title: getMappedData('currentImpact_9'),
        value1: formData.currentImpact_9,
      },
      {
        key: "currentImpact_10",
        title: getMappedData('currentImpact_10'),
        value1: formData.currentImpact_10,
      },
    ]);

    setConcordanceCard([
      {
        key: "concordance_ack_1",
        title: getMappedData('concordance_ack_1'),
        value1: (<div>- {toTitleCase(formData.concordance_ack_1)}</div>),
      },
      {
        key: "concordance_ack_2",
        title: getMappedData('concordance_ack_2'),
        value1: (<div>- {toTitleCase(formData.concordance_ack_2)}</div>),
      },
      {
        key: "concordance_ack_3_value",
        title: getMappedData('concordance_ack_3'),
        value1: groupedCheckboxesPreview(
          formData,
          'concordance_ack_3',
          ['concordance_ack_3_value_1', 'concordance_ack_3_value_2', 'concordance_ack_3_value_3'],
        ),
      }
    ]);

    setIndividualIRMPackage([
      {
        key: "financialIRM",
        title: "Financial IRM",
        value1: (
            <>
              {formData.financialIRM && formData.financialIRM.map((item, index) => (
                  <div key={index}><CheckOutlined style={{ fontSize: 10 }} /> {toTitleCase(item)}</div>
              ))}
            </>
        ),
      },
      {
        key: "financialIRMDetails",
        title: "Details of selected measures",
        value1: formData.financialIRMDetails,
      },
      {
        key: "psychologicalIRM",
        title: "Psychological IRM",
        value1: (
            <>
              {formData.psychologicalIRM && formData.psychologicalIRM.map((item, index) => (
                  <div key={index}><CheckOutlined style={{ fontSize: 10 }} /> {toTitleCase(item)}</div>
              ))}
            </>
        ),
      },
      {
        key: "psychologicalIRMDetails",
        title: "Details of selected measures",
        value1: formData.psychologicalIRMDetails,
      },
      {
        key: "medicalIRM",
        title: "Medical IRM",
        value1: (
            <>
              {formData.medicalIRM && formData.medicalIRM.map((item, index) => (
                  <div key={index}><CheckOutlined style={{ fontSize: 10 }} /> {toTitleCase(item)}</div>
              ))}
            </>
        ),
      },
      {
        key: "medicalIRMDetails",
        title: "Details of selected measures",
        value1: formData.medicalIRMDetails,
      },
      {
        key: "accompaniment",
        title: "Please indicate any personal preferences in terms of accompaniment (for example, if you prefer to meet case workers outside your home)",
        value1: formData.accompaniment,
      },
      {
        key: "closingTheInterview",
        title: "Is there anything you would like to add, before we end the interview?",
        value1: formData.closingTheInterview,
      },
      {
        key: "place",
        title: "place",
        value1: formData.place,
      },
    ]);

  }, [formData]);
  useEffect(() => {
    // setTimeout(() => {
      if (section && formData.age) {
        const element = document.getElementById(section);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    // }, 600)
  }, [formData]);
  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: "32%",
    },
    {
      title: "Value",
      dataIndex: "value1",
      key: "value1",
    },
  ]
  return (
    <>
      <Card
        bordered={false}
        className="criclebox tablespace mb-24"
        title="Basic Information"
        id={'basicInfo'}
        extra={
          <>{ hasEditPermission && mode === "view" &&
              <Button
                  onClick={() => navigate(`/location/${campaignUUID}/interview/edit/${interviewId}?tab=basicInfo`)}
              >
                Update
              </Button>
          }
          </>
        }
      >
        <Table
          columns={columns}
          dataSource={basicInfo}
          pagination={false}
          className="ant-border-space"
        />
      </Card>
      <Card
        bordered={false}
        className="criclebox tablespace mb-24"
        title="Current Impact"
        id={'currentImpact'}
        extra={
          <>{ hasEditPermission && mode === "view" &&
              <Button
                  onClick={() => navigate(`/location/${campaignUUID}/interview/edit/${interviewId}?tab=currentImpact`)}
              >
                Update
              </Button>
          }
          </>
        }
      >
        {currentImpact.map((item, index) => (
          <div key={index} style={{padding: "20px"}}>
            <h3>{item.title}</h3>
            <p>{item.value1}</p>
          </div>
        ))}
      </Card>
      <Card
        bordered={false}
        className="criclebox tablespace mb-24"
        title="Concordance Card"
        id={'concordanceCard'}
        extra={
          <>{ hasEditPermission && mode === "view" &&
              <Button
                  onClick={() => navigate(`/location/${campaignUUID}/interview/edit/${interviewId}?tab=concordanceCard`)}
              >
                Update
              </Button>
          }
          </>
        }
      >
        {concordanceCard.map((item, index) => (
          <div key={index} style={{paddingLeft: "20px", paddingTop: '10px'}}>
            <h4>{item.title}</h4>
            <p>{item.value1}</p>
          </div>
        ))}
      </Card>
      <Card
        bordered={false}
        className="criclebox tablespace mb-24"
        title="Acknowledgement"
        id={'acknowledgement'}
        extra={
          <>{ hasEditPermission && mode === "view" &&
              <Button
                  onClick={() => navigate(`/location/${campaignUUID}/interview/edit/${interviewId}?tab=acknowledgement`)}
              >
                Update
              </Button>
          }
          </>
        }
      >
        <div style={{paddingLeft: "20px", paddingTop: '10px'}}>
          {formData.acknowledge === 'yes' && <div><CheckOutlined style={{ fontSize: 10, color: 'green' }} /> {getMappedData('acknowledge_1')}</div>}
          {formData.acknowledge === 'no' && <div><CloseOutlined style={{ fontSize: 10, color: 'red' }} /> {getMappedData('acknowledge_2')}</div>}
        </div>
        <div style={{paddingLeft: "20px", paddingTop: '10px'}}>
          <h4>Other Options</h4>
          <p>{formData.ackOtherOptions}</p>
        </div>
      </Card>
      <Card
        bordered={false}
        className="criclebox tablespace mb-24"
        title="Observation"
        id={'observation'}
        extra={
          <>{ hasEditPermission && mode === "view" &&
              <Button
                  onClick={() => navigate(`/location/${campaignUUID}/interview/edit/${interviewId}?tab=observation`)}
              >
                Update
              </Button>
          }
          </>
        }
      >
        {formData['feedback_ack_2_description'] && (
          <div style={{paddingLeft: "20px", paddingTop: '10px'}}>
            {/*<h4>Explanation</h4>*/}
            <p>{formData.feedback_ack_2_description}</p>
          </div>
        )}
      </Card>
      <Card
        bordered={false}
        className="criclebox tablespace mb-24"
        title="Violence Information"
        id={'violenceInformation'}
        extra={
          <>{ hasEditPermission && mode === "view" &&
              <Button
                  onClick={() => navigate(`/location/${campaignUUID}/interview/edit/${interviewId}?tab=violenceInformation`)}
              >
                Update
              </Button>
          }
          </>
        }
      >
        <Table
          columns={columns}
          dataSource={violenceInformation}
          pagination={false}
          className="ant-border-space"
        />
      </Card>
      { mode === "view" &&
        <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title="Individual IRM Package"
            id={'irmPackage'}
            extra={
              <>{ hasEditPermission && mode === "view" &&
                  <Button
                      onClick={() => navigate(`/location/${campaignUUID}/interview/edit/${interviewId}?tab=irmPackage`)}
                  >
                    Update
                  </Button>
              }
              </>
            }
        >
          {!formData?.medicalIRM &&
              <div style={{padding: "20px", paddingTop: '10px'}}>Please update the Individual IRM Package for
                this survivor</div>}
          {formData?.medicalIRM &&
              <Table
              columns={columns}
              dataSource={individualIRMPackage}
              pagination={false}
              className="ant-border-space"
          />
          }
        </Card>
      }
    </>
  )
}
